<template>
  <b-navbar toggleable="md" fixed="top" type="dark" variant="dark" class="aegis-dark">
    <b-container class="py-0">
      <b-navbar-brand :to="{name: 'home'}" v-if="STUDY != 'eavetubes'">AEGIS</b-navbar-brand>
      <b-navbar-brand :to="{name: 'home'}" v-else>Eave Tubes</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <!-- <b-nav-item>About</b-nav-item> -->
          <b-nav-item :to="{name: 'dashboard'}">Data Portal</b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item :to="{name: 'login', query: { next: '/dashboard'}}" v-if="!user.email">Sign In</b-nav-item>
          <!-- simply use no-caret instead of no-caret="true" to avoid type error -->
          <b-nav-item-dropdown right no-caret v-if="user.email">
            <template slot="button-content">
              <i class="fas fa-user-circle tw-text-2xl"></i>
            </template>
            <b-dropdown-item :to="{name: 'user'}">Profile</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="logout()">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState("user", ["user"])
  },
  methods: {
     ...mapActions(["setBaseComponent", "clearAuthorizationToken"]),
     ...mapActions("user", ["setUser"]),
    toggle: function() {
      this.drawer = !this.drawer;
    },
    logout: function() {
      this.clearAuthorizationToken();
      this.setUser({});

      this.$notify({
        text: "You have been logged out",
        duration: 10000,
        type: "warn"
      });

      this.$router.push({
        name: "home"
      });
    }
  }
};
</script>

<style>
.bg-dark.aegis-dark {
  background-color: #18487C!important;
}
</style>